import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const exportToExcel = (tableData, fileName) => {
   const worksheet = XLSX.utils.json_to_sheet(tableData);
       const workbook = XLSX.utils.book_new();
       XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
   
       const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
       const data = new Blob([excelBuffer], { type: "application/octet-stream" });
       saveAs(data, `${fileName}.xlsx`);
}

export default exportToExcel


